module.exports = __webpack_public_path__ + "img/EDF_120X35.66b9f419.png";